export default "/institutions/brand-visa.svg";